import type * as React from 'react';

export interface PracticeIconProps extends React.ComponentProps<'svg'> {
  size?: number;
}

/**
 * The mark for Oefenen — the design prototypes' own glyph: a fast-forward run
 * up against the end bar, "play it through before it happens for real".
 *
 * Not a lucide icon. The nearest ones say the wrong thing: theatre masks read
 * as pretending, and lucide's own fast-forward has no end bar, which is the
 * half of the glyph that says the run has somewhere to arrive.
 */
export function PracticeIcon({ size = 20, ...props }: PracticeIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth={1.8}
      strokeLinecap='round'
      strokeLinejoin='round'
      aria-hidden='true'
      {...props}
    >
      <path d='M4 6.4 12 12l-8 5.6z' />
      <path d='M11.6 6.4 19.6 12l-8 5.6z' />
      <path d='M21.2 6.4v11.2' />
    </svg>
  );
}
